import React, { Component } from "react";
import { connect } from "react-redux";
import HireButton from "../../Common/Hire";
import SendEmail from "../../Common/SendEmail";
import QuotationPrice from "../../Common/Quotation/Price";
import PriceLines from "../../Common/Quotation/PriceLines";
import Loader from '../../Common/Loader';
import SelectedAnswers from './SelectedAnswers';
import ErrorMessage from '../../Common/ErrorMessage';
import { home, client } from "../../../operations";
import { 
  setInnerPagesList,
  setStepInnerPage,
  decreaseStepByOne
} from '../../../actions';

class Quotation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      continue: true,
    };

    this.priceContent = this.priceContent.bind(this);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { stepInnerPage, setInnerPagesList } = this.props;
    if(!stepInnerPage || stepInnerPage.name !== 'sendEmail')
      setInnerPagesList([
        { name: 'quotation', back: '' },
        { name: 'sendEmail', back: '', backButton: false }
      ]);
  }

  priceContent() {
    const iconCheck = <span className="Price-icon-check" />;

    const contentLeft = [
      {value:iconCheck, label:'Incendio y Rayo'},
      {value:iconCheck, label:'Explosión de calderas o aparatos de vapor'},
      {value:iconCheck, label:'Explosión de gas de uso doméstico'},
      {value:iconCheck, label:'Huracanes, tornados o vendavales'},
      {value:iconCheck, label:'Caída de árboles'},
      {value:iconCheck, label:'Impacto de vehículos de terceros'},
      {value:iconCheck, label:'Daños por humo'},
      {value:iconCheck, label:'Incendio por tumulto o alborotos populares'},
    ];

    const contentRight = [
      {value:iconCheck, label:'Daños por huelga y daños maliciosos'},
      {value:iconCheck, label:'Caída de aeronaves o sus partes'},
      {value:iconCheck, label:'Remoción de escombros'},
      {value:iconCheck, label:'Pérdida de alquilere'},
      {value:iconCheck, label:'Cobertura de hurto'},
      {value:iconCheck, label:'Responsabilidad Civil: hasta U$S 50.000'},
      {value:iconCheck, label:'Cristales exteriores: hasta U$S 150'},
      {value:iconCheck, label:'Emergencia domiciliaria'},
    ];

    return(
      <>
        <div className="Price-title-content">
          <label>
            ¿Frente a que me protege esta cobertura?
          </label>
        </div>
        <PriceLines contentLeft={contentLeft} contentRight={contentRight}/>
      </>
    );
  }

  render() {

    const { 
      stepInnerPage, loading, quoteId,
      sendQuoteByEmail, quoter, getQuotation,
      errorMessage, setStepInnerPage
    } = this.props;

    switch (stepInnerPage.name) {
      case 'quotation':
        return (<div>
                  { loading ? 
                      <Loader /> :
                      quoteId > 0 ?
                        <div>
                          <SelectedAnswers />
                          <div>
                            <QuotationPrice
                              header='Tu inversión será de'
                              currency='U$S'
                              footerFeesOn={true}
                              priceContent={this.priceContent} 
                            />
                            <HireButton onThinkClick={() => {
                              setStepInnerPage('sendEmail');
                              sendQuoteByEmail(quoter);
                            }}/>
                          </div>
                        </div> : errorMessage ?
                        <ErrorMessage 
                          errorText='Tuvimos un inconveniente con la cotización'
                          tryAgainText= 'Volver a cotizar'
                          tryAgainAction={getQuotation}
                        /> : null
                  }
                </div>);
      case 'sendEmail':
        return <SendEmail />;
    };
    return <div/>;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    loading: state.steps.isLoading,
    errorMessage: state.quotation.errorMessage,
    stepInnerPage: state.steps.stepInnerPage,
    
    quoteId: state.quotation.quoteId,
    quoter: state.options.quoter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setInnerPagesList: (page) => {
      dispatch(setInnerPagesList(page));
    },
    setStepInnerPage: (page) => {
      dispatch(setStepInnerPage(page));
    },
    getQuotation: () => {
      dispatch(home.getQuotation());
    },
    sendQuoteByEmail: (quoter) => {
      dispatch(client.sendQuoteByEmail(quoter));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Quotation);